module.exports = __webpack_public_path__ + "static/media/logo-yellow.3825e32b.svg";